import { createStore } from 'vuex';
import { useSession } from '@/composables/useSession';

const { userData } = useSession();

export default createStore({
  state: {
    sessionVariable: null,
    tieneReservacionActiva: false,
    reservaParams: null,
    confirmaPagoParams: null,
    searchFilter: null,
  },
  mutations: {
    setSessionVariable(state, value) {
      state.sessionVariable = value;
    },
    setReservacionActiva(state, value) {
      state.tieneReservacionActiva = value;
    },
    setReservaParams(state, payload) {
      state.reservaParams = payload;
    },
    setSearchFilter(state, payload) {
      state.searchFilter = payload;
    },
    setConfirmaPagoParams(state, payload) {
      state.confirmaPagoParams = payload;
    },
  },
  actions: {
    updateSessionVariable({ commit }, value) {
      commit('setSessionVariable', value);
    },
    updateReservacionActiva({ commit }, value) {
      commit('setReservacionActiva', value);
    },
    updateReservaParams({ commit }, payload) {
      commit('setReservaParams', payload);
    },
    updateConfirmaPagoParams({ commit }, payload) {
      commit('setConfirmaPagoParams', payload);
    },
    updateSearchFilter({ commit }, payload) {
      commit('setSearchFilter', payload);
    },
  },
  getters: {
    getSessionVariable: state => state.sessionVariable,
    getReservacionActiva: state => state.tieneReservacionActiva,
    getReservaParams: state => state.reservaParams,
    getConfirmaPagoParams: state => state.confirmaPagoParams,
    getSearchFilter: state => state.searchFilter,
  },
  modules: {
    personaDocumentos: {
      namespaced: true,
      state: () => ({
        imgIneFrontalBase64: null,
        imgIneReversoBase64: null,
        imgSelfieIneBase64: null,
        imgComprobanteDomicilioBase64: null,
        imgAntecedentesPenalesBase64: null,
      }),
      mutations: {
        establecerImgIneFrontalBase64(state, { imagenBase64 }) {
          state.imgIneFrontalBase64 = imagenBase64;
        },
        establecerImgIneReversoBase64(state, { imagenBase64 }) {
          state.imgIneReversoBase64 = imagenBase64;
        },
        establecerImgSelfieIneBase64(state, { imagenBase64 }) {
          state.imgSelfieIneBase64 = imagenBase64;
        },
        establecerImgComprobanteDomicilioBase64(state, { imagenBase64 }) {
          state.imgComprobanteDomicilioBase64 = imagenBase64;
        },
        establecerImgAntecedentesPenalesBase64(state, { imagenBase64 }) {
          state.imgAntecedentesPenalesBase64 = imagenBase64;
        },
      },
      getters: {
        obtenerImgIneFrontalBase64: state => state.imgIneFrontalBase64,
        obtenerImgIneReversoBase64: state => state.imgIneReversoBase64,
        obtenerImgSelfieIneBase64: state => state.imgSelfieIneBase64,
        obtenerImgComprobanteDomicilioBase64: state => state.imgComprobanteDomicilioBase64,
        obtenerImgAntecedentesPenalesBase64: state => state.imgAntecedentesPenalesBase64,
      }
    }
  }
});
